/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_When_LabelInputs */

const en_us2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When does it hurt?`)
};

const pt_br2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando dói?`)
};

const es_419_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo duele?`)
};

const pt_pt2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando dói?`)
};

const fr_fr2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand as-tu mal ?`)
};

const de_de2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann tut es weh?`)
};

const it_it2_bodymap_when_label = /** @type {(inputs: Bodymap_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando fa male?`)
};

/**
* | output |
* | --- |
* | "When does it hurt?" |
*
* @param {Bodymap_When_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_when_label = /** @type {((inputs?: Bodymap_When_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_When_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_when_label(inputs)
	if (locale === "es-419") return es_419_bodymap_when_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_when_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_when_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_when_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_when_label(inputs)
	return en_us2_bodymap_when_label(inputs)
});
export { bodymap_when_label as "bodymap.when.label" }